import React from 'react';
import { Button } from '@mui/material';

const VIOLET_SX = {
  backgroundColor: '#6c44cf',
  color: '#fff',
  textTransform: 'none',
  '&:hover': { backgroundColor: '#5a39b5' },
};

/**
 * Purple accent for project download / finish dialogs (Requests).
 */
const ProjectVioletButton = React.forwardRef(function ProjectVioletButton({ sx, ...props }, ref) {
  return <Button ref={ref} variant="contained" sx={[VIOLET_SX, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} {...props} />;
});

export default ProjectVioletButton;
